import { render } from "./Sales.vue?vue&type=template&id=cdbf2ec0&scoped=true"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"

import "./custom-sales.scss?vue&type=style&index=0&id=cdbf2ec0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdbf2ec0"]])

export default __exports__